import { QueryClient } from '@tanstack/react-query';
import { ApiError } from './api';

/** アプリ全体で 1 つの QueryClient */
export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        refetchOnWindowFocus: false,
        // 4xx はリトライしない（権限・入力エラーは何度呼んでも同じ）
        retry: (failureCount, error) => {
          if (error instanceof ApiError && error.status >= 400 && error.status < 500) return false;
          return failureCount < 2;
        },
      },
      mutations: { retry: false },
    },
  });
}
